module.exports = __webpack_public_path__ + "img/Doc.6f4f030f.svg";